import React, {useEffect, useRef, useState} from "react";
import BankManagerView from "./partial/bankManagerView";
import Api from "../../Api/api";
import {useStateValue} from "../../states/StateProvider";
import {useNavigate} from "react-router";
import useModal from "../../hooks/useModal";
import AddUsers from "../../components/modal/addUsers";
import {toast} from "react-toastify";
import {BeatLoader} from "react-spinners";
import {GrUserAdmin} from "react-icons/gr";
import {MdSupervisorAccount} from "react-icons/md";
import {FaBan, FaTasks, FaUser, FaUserSecret} from "react-icons/fa";
import {AES, enc} from "crypto-js";
import AdminView from "./partial/adminView";
import ExcelExportUsers from "./partial/excelExport";

const UserManagement = () => {
    const [search, setSearch] = useState('')
    const [searchKey, setSearchKey] = useState('')
    const [users, setUsers] = useState([])
    const [allUsers, setAllUsers] = useState([])
    const [usersExport, setUsersExport] = useState([])
    const [roleFilter, setRoleFilter] = useState({i: true, er: true, ed: true, mr: true, md: true, c: true})
    const [roleSearchFilter, setRoleSearchFilter] = useState('')
    const [searchResults, setSearchResults] = useState([])
    const [{
        secretKey,
        userValidated,
        page,
        addUsersModal,
        sortUserColum,
        sortUserMethod,
        filterIDUM,
        filterUM,
        addUsersDone,
        portal
    }, dispatch] = useStateValue();
    const decryptedBytes = localStorage.getItem('user') ? AES.decrypt(localStorage.getItem('user'), secretKey) : false;
    const user = JSON.parse(decryptedBytes.toString(enc.Utf8))
    const admin = user.isUserAdmin
    const userID = user.ID
    const role = user.role
    const [rows, setRows] = useState('10');
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);
    const [loadingKeys, setLoadingKeys] = useState(false);
    const [modal, setModal] = useState(false)
    const navigate = useNavigate()
    const {toggleAddUsersModal} = useModal();
    const modalRef = useRef()

    useEffect(() => {
        const delayQuery = setTimeout(async () => {
            if (roleSearchFilter) {
                return;
            }
            getUsers(searchKey)
        }, Object.values(filterUM).filter(k => k !== null).length > 0 ? 2000 : 0)

        return () => clearTimeout(delayQuery)

    }, [rows, userID, userValidated, page, sortUserMethod, sortUserColum, addUsersDone, searchKey, filterUM, roleFilter]);

    useEffect(() => {
        if (roleSearchFilter) {
            getUsersForRoleFilter()
        } else {
            getUsers(searchKey)
        }
    }, [roleSearchFilter]);

    useEffect(() => {
        const delayQuery = setTimeout(async () => {
            if (search.match(/^ *$/) === null) {
                let data = new FormData()
                data.append('userID', userID)
                data.append('search', search)

                setLoadingKeys(true)
                Api().post('/searchByMail', data).then(res => {
                    setSearchResults(res.data)
                    setLoadingKeys(false)
                    dispatch({type: "SET_PAGE", item: 1})
                }).catch((error) => {
                    setLoadingKeys(false)
                    toast.error('HOPPLA! etwas ist schief gelaufen')
                })
            }
        }, search ? 1500 : 0)

        return () => clearTimeout(delayQuery)
    }, [search])

    useEffect(() => {
        if (searchResults.length > 0) {
            setModal(true)
        }
    }, [searchResults]);

    useEffect(() => {
        document.addEventListener('mousedown', (e) => {
            if (!modalRef.current.contains(e.target)) {
                setModal(false)
            }
        })
    }, []);

    useEffect(() => {
        if (!search) {
            setSearchKey('')
            setModal(false)
            setSearchResults([])
        }
    }, [search]);

    useEffect(() => {
        setSearch('')
    }, [userValidated]);

    function getUsers(src) {
        if (role === 'ExtDGG' || role === 'ExtRUV') {
            navigate('/')
        }
        setLoading(true)
        let data = new FormData()
        data.append('userID', userID)
        data.append('rows', rows)
        data.append('page', page)
        data.append('search', src)
        data.append('sortColumn', sortUserColum)
        data.append('sortMethod', sortUserMethod)
        data.append('vp', filterUM.c)
        data.append('I', roleFilter.i ? '1' : '0')
        data.append('C', roleFilter.c ? '1' : '0')
        data.append('ER', roleFilter.er ? '1' : '0')
        data.append('MR', roleFilter.mr ? '1' : '0')
        data.append('ED', roleFilter.ed ? '1' : '0')
        data.append('MD', roleFilter.md ? '1' : '0')

        Api().post('/getUsers', data).then(res => {

            setUsers(res.data)
            if (res.data.length > 0) {
                setTotal(Number(res.data[0].totalUsers))
            } else {
                setTotal(0)
            }
            setLoading(false)

        }).catch(e => {
            setLoading(false)
            toast.error('etwas ist schief gelaufen!')
        })
    }

    function getUsersForRoleFilter() {
        if (role === 'ExtDGG' || role === 'ExtRUV') {
            navigate('/')
        }
        setLoading(true)
        let data = new FormData()
        data.append('userID', userID)
        data.append('rows', '10000')
        data.append('page', 1)
        data.append('search', searchKey)
        data.append('sortColumn', sortUserColum)
        data.append('sortMethod', sortUserMethod)
        data.append('vp', filterUM.c)
        data.append('I', roleFilter.i ? '1' : '0')
        data.append('C', roleFilter.c ? '1' : '0')
        data.append('ER', roleFilter.er ? '1' : '0')
        data.append('MR', roleFilter.mr ? '1' : '0')
        data.append('ED', roleFilter.ed ? '1' : '0')
        data.append('MD', roleFilter.md ? '1' : '0')

        Api().post('/getUsers', data).then(res => {
            setAllUsers(res.data)

            const roleMap = {
                'Internal': 'innendienst',
                'ExtRUV': 'fkb',
                'ExtDGG': 'vp',
                'Controller': 'controlling',
                'ManRUV': 'management',
                'ManDGG': 'struktur'
            }

            const filtered = res.data.filter(u => {
                const roleName = roleMap[u.role] || u.role
                return roleName.toLowerCase().includes(roleSearchFilter.toLowerCase())
            })

            setUsers(filtered)
            setTotal(filtered.length)
            setLoading(false)

        }).catch(e => {
            setLoading(false)
            toast.error('etwas ist schief gelaufen!')
        })
    }

    function setUpModal(e) {
        setSearchKey(e.target.value)
        setSearch(e.target.value)
        setModal(false)
    }

    function searchSubmit(e) {
        e.preventDefault();
        getUsers(search)
        setModal(false)
    }

    function setPageStates(e) {
        dispatch({type: "SET_PAGE", item: 1})
        setRows(e.target.value)
    }

    function excelExport() {
        Api().get('sp_getDataUserAuswertung').then(res => {
            console.log('data', res.data)
            setUsersExport(res.data)
        })
    }

    return (<div className='dashboardContainer'>
        <div className='lg:flex justify-between pt-2 sm:block'>
            <h2 className='text-2xl lg:text-left'>{admin === '0' ? 'Benutzerübersicht' : 'Benutzerverwaltung'}</h2>
            <div className={admin === '0' || user.role === 'Controlling' ? 'hidden' : ''}>
                <p className={`px-3 py-2 shadow shadow-md shadow-mainBlue rounded-2xl hover:bg-white hover:text-mainBlue bg-mainBlue text-sm text-white ml-2 cursor-pointer`}
                   onClick={toggleAddUsersModal}>
                    Neuen Benutzer anlegen
                </p>
            </div>
        </div>
        <div className={`bg-white my-4`}>
            <div className={`rounded-xl p-8 lg:flex lg:justify-between sm:block`}>
                <div className='flex items-center gap-4'>
                    <form onSubmit={searchSubmit} className='xl:w-80 sm:w-full'>
                        <input type="text" className='w-full'
                               value={search}
                               placeholder='Suche..'
                               onChange={(e) => setSearch(e.target.value)}
                        />
                        <input type="submit" value="Submit" hidden/>
                    </form>
                    <div>
                        <ExcelExportUsers url={'/sp_getDataUserAuswertung'}
                                          title={'Excel Export'}
                                          portal={portal}
                                          classStyles={'mt-0'}/>
                    </div>
                </div>

                <div className='flex flex-col -mt-5'>
                    <h3 className='text-sm font-semibold mb-2 text-gray-700'>Benutzer-Rolle <span
                        style={{fontWeight: 'normal'}}>(aktivieren/deaktivieren)</span></h3>
                    <div className='flex flex-col gap-1.5'>
                        {/* Row 1: Alle, Controlling, Struktur, Management */}
                        <div className='flex gap-1.5'>
                            <div
                                className={`flex w-24 justify-start items-center cursor-pointer px-1.5 py-0.5 border-2 rounded text-xs ${roleFilter.i && roleFilter.er && roleFilter.ed && roleFilter.mr && roleFilter.md && roleFilter.c ? 'border-mainBlue bg-blue-50' : 'border-gray-300 opacity-50'}`}
                                onClick={() => user.isUserAdmin === '1' && setRoleFilter({
                                    ...roleFilter, mr: 1, c: 1, i: 1, er: 1, ed: 1, md: 1
                                })}>
                                <FaTasks size={'14px'} color={'#565c8c'}/> <span
                                className='ml-1'>Alle</span>
                            </div>
                            <div
                                className={`flex w-24 justify-start items-center cursor-pointer px-1.5 py-0.5 border-2 rounded text-xs ${roleFilter.c ? 'border-mainBlue bg-blue-50' : 'border-gray-300 opacity-50'}`}
                                onClick={() => user.isUserAdmin === '1' && setRoleFilter({
                                    ...roleFilter, c: !roleFilter.c
                                })}>
                                <FaUserSecret size={'14px'} color={'#565c8c'}/> <span
                                className='ml-1'>Controlling</span>
                            </div>
                            <div
                                className={`flex w-24 justify-start items-center cursor-pointer px-1.5 py-0.5 border-2 rounded text-xs ${roleFilter.md ? 'border-mainBlue bg-blue-50' : 'border-gray-300 opacity-50'}`}
                                onClick={() => user.isUserAdmin === '1' && setRoleFilter({
                                    ...roleFilter, md: !roleFilter.md
                                })}>
                                <FaUser size={'14px'} color={'#0a523f'}/> <span
                                className='ml-1'>Struktur</span>
                            </div>
                            <div
                                className={`flex w-24 justify-start items-center cursor-pointer px-1.5 py-0.5 border-2 rounded text-xs ${roleFilter.mr ? 'border-mainBlue bg-blue-50' : 'border-gray-300 opacity-50'}`}
                                onClick={() => user.isUserAdmin === '1' && setRoleFilter({
                                    ...roleFilter, mr: !roleFilter.mr
                                })}>
                                <FaUser size={'14px'} color={'#565c8c'}/> <span
                                className='ml-1'>Management</span>
                            </div>
                        </div>
                        {/* Row 2: Keine, Innendienst, VP, FKB */}
                        <div className='flex gap-1.5'>
                            <div
                                className={`flex w-24 justify-start items-center cursor-pointer px-1.5 py-0.5 border-2 rounded text-xs ${!roleFilter.i && !roleFilter.er && !roleFilter.ed && !roleFilter.mr && !roleFilter.md && !roleFilter.c ? 'border-mainBlue bg-blue-50' : 'border-gray-300 opacity-50'}`}
                                onClick={() => user.isUserAdmin === '1' && setRoleFilter({
                                    ...roleFilter, mr: 0, c: 0, i: 0, er: 0, ed: 0, md: 0
                                })}>
                                <FaBan size={'14px'} color={'#565c8c'}/> <span
                                className='ml-1'>Keine</span>
                            </div>
                            <div
                                className={`flex w-24 justify-start items-center cursor-pointer px-1.5 py-0.5 border-2 rounded text-xs ${roleFilter.i ? 'border-mainBlue bg-blue-50' : 'border-gray-300 opacity-50'}`}
                                onClick={() => user.isUserAdmin === '1' && setRoleFilter({
                                    ...roleFilter, i: !roleFilter.i
                                })}>
                                <GrUserAdmin size={'14px'} color={'#565c8c'}/> <span
                                className='ml-1'>Innendienst</span>
                            </div>
                            <div
                                className={`flex w-24 justify-start items-center cursor-pointer px-1.5 py-0.5 border-2 rounded text-xs ${roleFilter.ed ? 'border-mainBlue bg-blue-50' : 'border-gray-300 opacity-50'}`}
                                onClick={() => user.isUserAdmin === '1' && setRoleFilter({
                                    ...roleFilter, ed: !roleFilter.ed
                                })}>
                                <MdSupervisorAccount size={'14px'} color={'#0a523f'}/><span
                                className='ml-1'>VP</span>
                            </div>
                            <div
                                className={`flex w-24 justify-start items-center cursor-pointer px-1.5 py-0.5 border-2 rounded text-xs ${roleFilter.er ? 'border-mainBlue bg-blue-50' : 'border-gray-300 opacity-50'}`}
                                onClick={() => user.isUserAdmin === '1' && setRoleFilter({
                                    ...roleFilter, er: !roleFilter.er
                                })}>
                                <MdSupervisorAccount size={'14px'} color={'#3A46A9'}/><span
                                className='ml-1'>FKB</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='absolute ml-40 -mt-24'>
                {loadingKeys && <BeatLoader size='6'/>}
            </div>

            <div ref={modalRef}
                 className={`${!modal && 'hidden'} absolute w-80 max-h-80 ml-8 bg-offWhite p-5 z-10 -mt-20 overflow-y-scroll`}>
                {searchResults?.map((res, i) => (<input type='button' key={i} onClick={setUpModal}
                                                        className='cursor-pointer flex flex-col text-mainBlue text-sm text-left border-none underline hover:text-red p-2'
                                                        value={res.email}
                />))}
            </div>

            <div>
                {(role === 'Internal' || role === 'Controller') ?
                    <AdminView role={role} users={users} pageSize={rows} total={total} loading={loading}
                               filterUM={filterUM}
                               filterIDUM={filterIDUM}
                               page={page}
                               setPageStates={setPageStates}
                               roleSearchFilter={roleSearchFilter}
                               setRoleSearchFilter={setRoleSearchFilter}/> : (role === 'ManDGG' || role === 'ManRUV') &&
                    <BankManagerView role={role} users={users} pageSize={rows} total={total} loading={loading}
                                     filterUM={filterUM} filterIDUM={filterIDUM}
                                     page={page}
                                     setPageStates={setPageStates}
                                     roleSearchFilter={roleSearchFilter}
                                     setRoleSearchFilter={setRoleSearchFilter}/>}
            </div>
        </div>

        {addUsersModal && <AddUsers />}
    </div>)
}

export default UserManagement
